import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import React, { useContext, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import DoorContext from '../../../context/DoorContext';
import { DoorFormData } from '../../../pages/DoorAdd';
import ControlledDoorModelAutocomplete from '../../forms/ControlledDoorModelAutocomplete';

interface DoorDoorModelAddProps {
  onContinue: () => void;
}

export default function DoorDoorModelAdd({ onContinue }: DoorDoorModelAddProps) {
  const { setDoor, door } = useContext(DoorContext);

  const form = useForm<Pick<DoorFormData, 'doorModel'>>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: door,
  });

  const { handleSubmit, watch } = form;

  const selectedDoorModel = watch('doorModel');

  const buttonText = useMemo(() => {
    return selectedDoorModel ? 'Continue' : 'Skip';
  }, [selectedDoorModel]);

  const submit = ({ doorModel }: Pick<DoorFormData, 'doorModel'>) => {
    setDoor((prev: DoorFormData | undefined) => ({ ...prev, doorModel }));
    onContinue();
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(submit)}>
        <Box display="flex" justifyContent="center">
          <ControlledDoorModelAutocomplete name="doorModel" label="Type a door model" />
        </Box>
        <Box display="flex" justifyContent="flex-end" marginTop={3}>
          <Button type="submit" variant="contained" color="primary">
            {buttonText}
          </Button>
        </Box>
      </form>
    </FormProvider>
  );
}
